​
@if (tableSkeleton) {
<lib-table-skeleton></lib-table-skeleton>
} @else {
@if (dataSource?.data) {
<ng-container>
  <div class=" rounded-b-2xl flex flex-col justify-between table-container-wrapper" [ngClass]="tableHeight">
    <div class="table-scroll-wrapper shadow-xl">
      <div class="table-wrapper" [ngClass]="fixedHeader ? 'fixed-header-wrapper' : ''" #tableWrapper
        (scroll)="onTableScroll($event)">
        <table mat-table [dataSource]="dataSource" matSort matSortDisableClear (matSortChange)="onSortChange($event)"
          class="w-full custom-table" [ngClass]="{
                'sticky-header-table': fixedHeader,
                'rounded-b-2xl': customizedPagiantor,
                'few-columns-table': isFewColumns,
              }">
          <ng-container *ngFor="let header of displayedColumns" [matColumnDef]="header.id">
            <!-- Custom template column -->
            <ng-container *ngIf="hasCustomTemplate(header.id)">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.title]="header.key">
                {{ header.key }}
              </th>
              <td mat-cell *matCellDef="let element">
                <ng-container *ngTemplateOutlet="
                        getCustomTemplate(header.id)!;
                        context: { $implicit: element, column: header.id }
                      ">
                </ng-container>
              </td>
            </ng-container>

            <!-- Existing column types -->
            <ng-container *ngIf="!hasCustomTemplate(header.id)">
              <!-- Copy URL column -->
              <ng-container *ngIf="header.id === 'copyUrl'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <button *ngIf="element.url"
                    class="flex items-center justify-center p-2 rounded-md transition-colors duration-200"
                    [disabled]="isCopyDisabled(element)" [class]="
                          element.copied
                            ? 'bg-green-100 text-green-600'
                            : isCopyDisabled(element)
                              ? 'text-gray-400 cursor-not-allowed'
                              : 'text-blue-600 hover:text-blue-800 hover:bg-blue-50'
                        " (click)="
                          copyUrl(element.url, element);
                          $event.stopPropagation()
                        " [title]="
                          isCopyDisabled(element)
                            ? 'Copy disabled for completed activities'
                            : 'Copy Quiz URL'
                        " #copyBtn>
                    <mat-icon class="text-lg" [class.text-green-600]="element.copied">content_copy</mat-icon>
                  </button>
                  <span *ngIf="!element.url" class="text-gray-400">--</span>
                </td>
              </ng-container>

              <!-- Training QR code column -->
              <ng-container *ngIf="header.id === 'trainingQrCode'">
                <th mat-header-cell *matHeaderCellDef>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <button *ngIf="element.url" type="button"
                    class="flex items-center justify-center p-2 rounded-md transition-colors duration-200"
                    [disabled]="isCopyDisabled(element)" [class]="
                          isCopyDisabled(element)
                            ? 'text-gray-400 cursor-not-allowed'
                            : 'text-blue-600 hover:text-blue-800 hover:bg-blue-50'
                        " (click)="
                          openTrainingQrCode(
                            element.url,
                            element.title
                              ? element.title + ' - QR Code'
                              : 'Join Training QR Code'
                          );
                          $event.stopPropagation()
                        " [title]="
                          isCopyDisabled(element)
                            ? 'QR code unavailable for this training'
                            : 'View QR Code'
                        ">
                    <mat-icon class="text-lg">qr_code_2</mat-icon>
                  </button>
                  <span *ngIf="!element.url" class="text-gray-400">--</span>
                </td>
              </ng-container>

              <!-- Radio button -->
              <ng-container *ngIf="header.id === 'selectRadio'">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-radio-group class="radio-group">
                    <!-- <mat-radio-button
                        [checked]="selection.hasValue() && isAllSelected()"
                        [aria-label]="checkboxLabel()"
                      >
                      </mat-radio-button> -->
                  </mat-radio-group>
                </th>
                <td mat-cell *matCellDef="let element">
                  <mat-radio-group [(ngModel)]="selectedRow" (change)="radioSelected(element)">
                    <mat-radio-button #button (click)="checkState(button); $event.stopPropagation()" [value]="element"
                      [aria-label]="checkBoxSelected(element)" (change)="
                            $event ? selection.select(element) : null;
                            callIt(element)
                          " [checked]="selection.isSelected(element)">
                    </mat-radio-button>
                  </mat-radio-group>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'select'">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="checkbox_container">
                    <mat-checkbox [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()"
                      (change)="toggleSelectAll($event.checked)" disableRipple>
                    </mat-checkbox>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">
                  <mat-checkbox #checkbox (click)="checkState(checkbox); $event.stopPropagation()" [value]="element"
                    [aria-label]="checkBoxSelected(element)" (change)="selection.toggle(element); callIt(element)"
                    [checked]="selection.isSelected(element)" disableRipple>
                  </mat-checkbox>
                </td>
              </ng-container>

              @if (
              ![
              'select-btn',
              'isCompetitor',
              'countriesName',
              'user_storeBtn',
              'survey_mapBtn',
              'resetPasswordBtn',
              'resetStoreLocationBtn',
              'task_status',
              'segment',
              'stores',
              'action',
              'brand',
              'state',
              'isInvoiceRequired',
              'isEnterPrice',
              'isCheckInImageRequired',
              'isAbleToMapStore',
              'isMultipleBrand',
              'isCheckinCheckoutValidation',
              'starProduct',
              'isPricePromotion',
              'isMobileAccess',
              'isWebAccess',
              'approved_by',
              'approver',
              'ro_full_name',
              'approvalstatus',
              'dob',
              'requestedDate',
              'startDate',
              'endDate',
              'startdate',
              'enddate',
              'approvedDate',
              'date',
              'selfi_img',
              'storeAdress',
              'address',
              'incentiveScheme',
              'empStatus',
              'isApproval',
              'pmAccess',
              'status',
              'status-text',
              'firstName',
              'region',
              'channel',
              'country',
              'account',
              'countries',
              'inviteDate',
              'store',
              'actions',
              'language',
              'invoicePriceUnit',
              'total',
              'grossPriceUnit',
              'grossPriceTotal',
              'reporting_manager',
              'quantity',
              'displayCount',
              'displayShare',
              'displayPlanogramDate',
              'display_share_date',
              'grossprice',
              'price',
              'fieldAction',
              'marketAction',
              'aegViewAction',
              'target',
              'store_code',
              'beforeImage1',
              'beforeImage2',
              'afterImage1',
              'afterImage2',
              'sno',
              'display_date',
              'displayDate',
              'storeAddress',
              'location',
              'saleDate',
              'invoiceUrl',
              'taggedImageurl',
              'untaggedImageurl',
              'image_url',
              'pre-test-image',
              'post-test-image',
              'promoter_brand',
              'subCategoryName',
              'allSubCategories',
              'tagModelName',
              'JAN-2025',
              'FEB-2025',
              'MAR-2025',
              'categoryName',
              'APR-2025',
              'MAY-2025',
              'JUN-2025',
              'JUL-2025',
              'AUG-2025',
              'SEP-2025',
              'OCT-2025',
              'NOV-2025',
              'DEC-2025',
              'noOfStores',
              'name',
              'attachment',
              'is_executed',
              'attendanceStatus',
              'quizAttended',
              'is_promotionactivewhileleaving',
              'rrp',
              'go_price',
              'reasonfornotimplemented',
              'remarks_reasonfornotimplemented',
              'promotionactivewhileleaving',
              'remarks_promotionactivewhileleaving',
              'weightage',
              'retailer_score',
              'elx_score',
              'retailer_weighted',
              'elx_weighted',
              'factor_name',
              'total_weighted',
              'salescontribution',
              'categories',
              'created_date',
              'subCategories',
              'incentive_status',
              'created_at',
              'target_input',
              'profile',
              'rangefrom',
              'rangeto',
              'rangeFrom',
              'rangeTo',
              'incentive',
              'updatedAt',
              'cancelAction',
              'type',
              'store_country',
              'image',
              'resolved_image',
              'created_by_name',
              'updated_by_name',
              'resolved_by_name',
              'created_date_time',
              'update_date_time',
              'resolved_date_time',
              'estimated_resolve_date',
              'snag_open_action',
              'snag_resolve_action',
              'snag_status_name',
              'priority',
              'comments',
              'comparison_result',
              'recommendations',
              'engagement_type',
              'assessment_level_types',
              'isTest',
              'auditProgress',
              'complete',
              'storeAction'
              ].includes(header.id)
              ) {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.title]="header.key" class="whitespace-nowrap" [ngClass]="{
                          brandHeader: grandTotalHeader.includes(header.id),
                          'font-extrabold': header.id === 'rowGrandTotal',
                        }">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true" class="whitespace-nowrap"
                  [ngStyle]="{
                          background: grandTotalHeader.includes(header.id)
                            ? '#d3d3d3'
                            : '',
                        }" (mouseleave)="element.isHidden = false">
                  <div [ngClass]="{
                            'text-center ': grandTotalHeader.includes(
                              header.id
                            ),
                            'font-extrabold': header.id === 'rowGrandTotal',
                          }">
                    {{
                    element[header.id] !== null &&
                    element[header.id] !== undefined &&
                    element[header.id] !== ''
                    ? element[header.id]
                    : '--'
                    }}
                  </div>
                </td>

                <ng-container *ngIf="grandTotalValue">
                  <td mat-footer-cell *matFooterCellDef style="background-color: #011e41">
                    <div class="font-extrabold text-center text-white">
                      {{
                      grandTotalHeader.includes(header.id)
                      ? grandTotalValue[header.id] !== null &&
                      grandTotalValue[header.id] !== undefined &&
                      grandTotalValue[header.id] !== ''
                      ? grandTotalValue[header.id]
                      : ''
                      : ''
                      }}
                    </div>
                  </td>
                </ng-container>
              </ng-container>
              } @else if (header.id === 'store_country') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div class="min-w-[120px] max-w-[250px]">
                    <div class="store_name font-bold">
                      {{ element.store_name }}
                    </div>
                    <div class="country_name">
                      {{ element.country_name }}
                    </div>
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'profile') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="text-center">
                  <div class="flex items-center justify-center">
                    @if (getImageSource(element, 'profile'); as profileSrc) {
                    <img *ngIf="!element.profileImageError" [src]="profileSrc" alt="Profile"
                      class="w-10 h-10 rounded-full object-cover border border-gray-300 cursor-pointer hover:opacity-80 transition-opacity"
                      (error)="element.profileImageError = true" (click)="openModal(element.profile, $event)" />
                    }
                    <svg *ngIf="
                              !getImageSource(element, 'profile') ||
                              element.profileImageError
                            " xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"
                      class="border border-gray-300 rounded-full p-1" fill="#949595">
                      <path
                        d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4" />
                    </svg>
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'action') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef>
                  {{ actionHeader ? 'Action' : '' }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="action-cell cursor-pointer">
                  <div *ngIf="
                            alwaysShowAction ||
                            element.isHidden ||
                            element['status-text'] === 'Scheduled'
                          " class="flex gap-6 items-center justify-center action-icons">
                    <div class="action-btn flex items-center justify-center" aria-label="Edit"
                      *ngIf="editRow && !element.hideEditBtn" (click)="
                              editUser(element); $event.stopPropagation()
                            ">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 12 12" fill="none">
                        <path
                          d="M8.5649 1.76063C8.69736 1.62817 8.85461 1.5231 9.02767 1.45142C9.20074 1.37973 9.38623 1.34283 9.57355 1.34283C9.76087 1.34283 9.94636 1.37973 10.1194 1.45142C10.2925 1.5231 10.4497 1.62817 10.5822 1.76063C10.7147 1.89309 10.8197 2.05034 10.8914 2.22341C10.9631 2.39647 11 2.58196 11 2.76929C11 2.95661 10.9631 3.1421 10.8914 3.31516C10.8197 3.48823 10.7147 3.64548 10.5822 3.77794L3.7738 10.5863L1 11.3428L1.75649 8.56904L8.5649 1.76063Z"
                          stroke="#32325D" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>

                    <div *ngIf="deleteRow && !element.hideDeleteBtn" (click)="
                              deleteUser(element); $event.stopPropagation()
                            " class="action-btn flex items-center justify-center" aria-label="Delete">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 10 12" fill="none">
                        <path d="M0.5 3.34235H1.5H9.5" stroke="#32325D" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path
                          d="M8.5 3.34283V10.3428C8.5 10.6081 8.39464 10.8624 8.20711 11.0499C8.01957 11.2375 7.76522 11.3428 7.5 11.3428H2.5C2.23478 11.3428 1.98043 11.2375 1.79289 11.0499C1.60536 10.8624 1.5 10.6081 1.5 10.3428V3.34283M3 3.34283V2.34283C3 2.07762 3.10536 1.82326 3.29289 1.63573C3.48043 1.44819 3.73478 1.34283 4 1.34283H6C6.26522 1.34283 6.51957 1.44819 6.70711 1.63573C6.89464 1.82326 7 2.07762 7 2.34283V3.34283"
                          stroke="#32325D" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'fieldAction') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef>
                  {{ actionHeader ? 'Action' : '' }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="action-cell cursor-pointer">
                  <div *ngIf="
                            element.isHidden &&
                            element['status-text'] === 'Scheduled' &&
                            !element.hideFieldAction
                          " class="flex gap-6 items-center justify-center action-icons">
                    <div class="action-btn flex items-center justify-center" aria-label="Edit" *ngIf="editRow" (click)="
                              editUser(element); $event.stopPropagation()
                            ">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 12 12" fill="none">
                        <path
                          d="M8.5649 1.76063C8.69736 1.62817 8.85461 1.5231 9.02767 1.45142C9.20074 1.37973 9.38623 1.34283 9.57355 1.34283C9.76087 1.34283 9.94636 1.37973 10.1194 1.45142C10.2925 1.5231 10.4497 1.62817 10.5822 1.76063C10.7147 1.89309 10.8197 2.05034 10.8914 2.22341C10.9631 2.39647 11 2.58196 11 2.76929C11 2.95661 10.9631 3.1421 10.8914 3.31516C10.8197 3.48823 10.7147 3.64548 10.5822 3.77794L3.7738 10.5863L1 11.3428L1.75649 8.56904L8.5649 1.76063Z"
                          stroke="#32325D" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>

                    <div *ngIf="deleteRow && !element.hideDeleteBtn" (click)="
                              deleteUser(element); $event.stopPropagation()
                            " class="action-btn flex items-center justify-center" aria-label="Delete">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 10 12" fill="none">
                        <path d="M0.5 3.34235H1.5H9.5" stroke="#32325D" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path
                          d="M8.5 3.34283V10.3428C8.5 10.6081 8.39464 10.8624 8.20711 11.0499C8.01957 11.2375 7.76522 11.3428 7.5 11.3428H2.5C2.23478 11.3428 1.98043 11.2375 1.79289 11.0499C1.60536 10.8624 1.5 10.6081 1.5 10.3428V3.34283M3 3.34283V2.34283C3 2.07762 3.10536 1.82326 3.29289 1.63573C3.48043 1.44819 3.73478 1.34283 4 1.34283H6C6.26522 1.34283 6.51957 1.44819 6.70711 1.63573C6.89464 1.82326 7 2.07762 7 2.34283V3.34283"
                          stroke="#32325D" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'aegViewAction') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'View' }}
                </th>
                <td mat-cell *matCellDef="let element" class="cursor-pointer">
                  <!-- <div class="flex gap-6 items-center justify-center "> -->
                  <div (click)="
                            viewAegSurvey(element); $event.stopPropagation()
                          ">
                    <mat-icon>visibility</mat-icon>
                  </div>
                  <!-- </div> -->
                </td>
              </ng-container>
              } @else if (header.id === 'marketAction') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef>
                  {{ actionHeader ? 'Action' : '' }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="action-cell cursor-pointer">
                  <div *ngIf="element.isHidden" class="flex gap-6 items-center justify-center action-icons">
                    <!-- <div
                          class="action-btn flex items-center justify-center"
                          aria-label="Edit"
                          *ngIf="editRow"
                          (click)="editUser(element); $event.stopPropagation()"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M8.5649 1.76063C8.69736 1.62817 8.85461 1.5231 9.02767 1.45142C9.20074 1.37973 9.38623 1.34283 9.57355 1.34283C9.76087 1.34283 9.94636 1.37973 10.1194 1.45142C10.2925 1.5231 10.4497 1.62817 10.5822 1.76063C10.7147 1.89309 10.8197 2.05034 10.8914 2.22341C10.9631 2.39647 11 2.58196 11 2.76929C11 2.95661 10.9631 3.1421 10.8914 3.31516C10.8197 3.48823 10.7147 3.64548 10.5822 3.77794L3.7738 10.5863L1 11.3428L1.75649 8.56904L8.5649 1.76063Z"
                              stroke="#32325D"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div> -->

                    <div *ngIf="deleteRow && !element.hideDeleteBtn" (click)="
                              deleteUser(element); $event.stopPropagation()
                            " class="action-btn flex items-center justify-center" aria-label="Delete">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 10 12" fill="none">
                        <path d="M0.5 3.34235H1.5H9.5" stroke="#32325D" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path
                          d="M8.5 3.34283V10.3428C8.5 10.6081 8.39464 10.8624 8.20711 11.0499C8.01957 11.2375 7.76522 11.3428 7.5 11.3428H2.5C2.23478 11.3428 1.98043 11.2375 1.79289 11.0499C1.60536 10.8624 1.5 10.6081 1.5 10.3428V3.34283M3 3.34283V2.34283C3 2.07762 3.10536 1.82326 3.29289 1.63573C3.48043 1.44819 3.73478 1.34283 4 1.34283H6C6.26522 1.34283 6.51957 1.44819 6.70711 1.63573C6.89464 1.82326 7 2.07762 7 2.34283V3.34283"
                          stroke="#32325D" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'attachment') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="action-cell cursor-pointer">
                  <div *ngIf="element.isHidden" class="flex gap-6 items-center justify-center action-icons">
                    <div (click)="
                              editUser(element); $event.stopPropagation()
                            ">
                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                        fill="#32325D">
                        <path
                          d="M720-330q0 104-73 177T470-80q-104 0-177-73t-73-177v-370q0-75 52.5-127.5T400-880q75 0 127.5 52.5T580-700v350q0 46-32 78t-78 32q-46 0-78-32t-32-78v-370h80v370q0 13 8.5 21.5T470-320q13 0 21.5-8.5T500-350v-350q-1-42-29.5-71T400-800q-42 0-71 29t-29 71v370q-1 71 49 120.5T470-160q70 0 119-49.5T640-330v-390h80v390Z" />
                      </svg>
                    </div>
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'actions') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="action-cell cursor-pointer">
                  <div *ngIf="element.isHidden" class="flex gap-6 items-center justify-center action-icons">
                    <div (click)="
                              editUser(element); $event.stopPropagation()
                            ">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 12 12" fill="none">
                        <path
                          d="M8.5649 1.76063C8.69736 1.62817 8.85461 1.5231 9.02767 1.45142C9.20074 1.37973 9.38623 1.34283 9.57355 1.34283C9.76087 1.34283 9.94636 1.37973 10.1194 1.45142C10.2925 1.5231 10.4497 1.62817 10.5822 1.76063C10.7147 1.89309 10.8197 2.05034 10.8914 2.22341C10.9631 2.39647 11 2.58196 11 2.76929C11 2.95661 10.9631 3.1421 10.8914 3.31516C10.8197 3.48823 10.7147 3.64548 10.5822 3.77794L3.7738 10.5863L1 11.3428L1.75649 8.56904L8.5649 1.76063Z"
                          stroke="#32325D" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'incentiveScheme') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{
                  element.incentiveScheme !== null &&
                  element.incentiveScheme !== undefined &&
                  element.incentiveScheme !== ''
                  ? element.incentiveScheme
                  : '--'
                  }}
                </td>
              </ng-container>
              } @else if (header.id === 'empStatus') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  @if (element.empStatus !== undefined) {
                  <mat-slide-toggle class="example-margin" [checked]="element.empStatus"
                    (click)="$event.stopPropagation()" (change)="
                              toggleStatus(element.id, element.empStatus)
                            ">
                  </mat-slide-toggle>
                  }
                </td>
              </ng-container>
              } @else if (header.id === 'cancelAction') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="cursor-pointer">
                  <mat-icon *ngIf="isCancelActionVisible(element)" class="text-red-500"
                    (click)="cancelTraining(element.id)">
                    cancel
                  </mat-icon>
                </td>
              </ng-container>
              } @else if (header.id === 'snag_resolve_action') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef>
                  {{ header.key }}
                </th>

                <td mat-cell *matCellDef="let element">
                  <div class="action-btn-group">
                    <div *ngIf="deleteRow && !element.hideDeleteBtn" (click)="
                              deleteUser(element); $event.stopPropagation()
                            " class="action-btn flex items-center justify-center" aria-label="Delete">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 10 12" fill="none">
                        <path d="M0.5 3.34235H1.5H9.5" stroke="#32325D" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path
                          d="M8.5 3.34283V10.3428C8.5 10.6081 8.39464 10.8624 8.20711 11.0499C8.01957 11.2375 7.76522 11.3428 7.5 11.3428H2.5C2.23478 11.3428 1.98043 11.2375 1.79289 11.0499C1.60536 10.8624 1.5 10.6081 1.5 10.3428V3.34283M3 3.34283V2.34283C3 2.07762 3.10536 1.82326 3.29289 1.63573C3.48043 1.44819 3.73478 1.34283 4 1.34283H6C6.26522 1.34283 6.51957 1.44819 6.70711 1.63573C6.89464 1.82326 7 2.07762 7 2.34283V3.34283"
                          stroke="#32325D" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>

                    <button class="table-action-btn view-btn" (click)="viewSnag(element)">
                      View
                    </button>

                    <button class="table-action-btn resolve-btn" (click)="resolveSnag(element)"
                      [disabled]="element.snag_status_name === 'Resolved'">
                      Resolve
                    </button>
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'snag_open_action') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef>
                  {{ header.key }}
                </th>

                <td mat-cell *matCellDef="let element">
                  <div class="action-btn-group">
                    <button class="table-action-btn view-btn" (click)="viewSnag(element)">
                      View
                    </button>

                    <button class="table-action-btn reopen-btn" (click)="reopenSnag(element)">
                      Reopen
                    </button>
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'isApproval') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  @if (shouldShowLeaveApprovalToggle(element)) {
                  <mat-slide-toggle class="example-margin" [checked]="element.isApproval"
                    (click)="$event.stopPropagation()" (change)="
                              toggleLeaveApproval(element.id, $event.checked)
                            ">
                  </mat-slide-toggle>
                  } @else {
                  <span class="text-gray-400">--</span>
                  }
                </td>
              </ng-container>
              } @else if (header.id === 'pmAccess') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
                  @if (element.pmAccess !== undefined) {
                  <mat-slide-toggle class="example-margin" [checked]="element.pmAccess"
                    [disabled]="element.pmAccessToggling === true"
                    (change)="togglePmAccess(element.id, $event.checked)"></mat-slide-toggle>
                  } @else {
                  <span class="text-gray-400">--</span>
                  }
                </td>
              </ng-container>
              } @else if (header.id === 'status') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  @if (
                  typeof element.status === 'string' &&
                  (element.status === 'Open' ||
                  element.status === 'In Progress' ||
                  element.status === 'Resolved' ||
                  element.status === 'Closed' ||
                  element.status === 'Sellable' ||
                  element.status === 'Non Sellable' ||
                  element.status === 'Non-Sellable' ||
                  element.status === 'Submitted' ||
                  element.status === 'Pending' ||
                  element.status === 'Completed')
                  ) {
                  <div>
                    <span class="rounded-lg px-3 py-1 text-xs font-semibold status-badge" [ngStyle]="{
                                color: getTextColor(element.status),
                                backgroundColor: getBackgroundColor(
                                  element.status
                                ),
                              }">
                      {{ element.status }}
                    </span>
                  </div>
                  } @else {
                  <div style="
                              display: flex;
                              justify-content: center;
                              align-items: center;
                              width: 100%;
                            ">
                    <mat-slide-toggle class="example-margin" [checked]="element.status"
                      (click)="$event.stopPropagation()" (change)="
                                toggleStatus(element.id, element.status)
                              ">
                    </mat-slide-toggle>
                  </div>
                  }
                </td>
              </ng-container>
              } @else if (header.id === 'status-text') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="status-column-header">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="status-column-cell">
                  <div class="flex justify-center">
                    <span class="px-3 py-1 rounded-full text-sm font-medium whitespace-nowrap"
                      [ngClass]="getStatusChipClass(element[header.id])">
                      {{
                      element[header.id] !== null &&
                      element[header.id] !== undefined &&
                      element[header.id] !== ''
                      ? element[header.id]
                      : '--'
                      }}
                    </span>
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'isInvoiceRequired') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  <mat-slide-toggle class="example-margin" [checked]="element.isInvoiceRequired"
                    (click)="$event.stopPropagation()" (change)="
                            toggleInvoiceRequired(
                              element.id,
                              element.isInvoiceRequired
                            )
                          ">
                  </mat-slide-toggle>
                </td>
              </ng-container>
              } @else if (header.id === 'isEnterPrice') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  <mat-slide-toggle class="example-margin" [checked]="element.isEnterPrice"
                    (click)="$event.stopPropagation()" (change)="
                            toggleEnterPrice(element.id, element.isEnterPrice)
                          ">
                  </mat-slide-toggle>
                </td>
              </ng-container>
              }
              @else if (header.id === 'isTest') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  @if (element.isTest !== undefined) {
                  <mat-slide-toggle class="example-margin" [checked]="element.isTest" (click)="$event.stopPropagation()"
                    (change)="
                            toggleTest(element.id, element.isTest)
                          ">
                  </mat-slide-toggle>
                  }
                </td>
              </ng-container>
              }
              @else if (header.id === 'auditProgress') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div class="flex items-center w-52 h-2.5 rounded-full overflow-hidden bg-[#B0BEC5] my-1 mx-auto">
                    <div *ngIf="element.foundPercent > 0" [style.width.%]="element.foundPercent"
                      class="h-full bg-[#6B7A66]" [title]="'Found: ' + element.found"></div>
                    <div *ngIf="element.notFoundPercent > 0" [style.width.%]="element.notFoundPercent"
                      class="h-full bg-[#937259]" [title]="'Not Found: ' + element.notFound"></div>
                    <div *ngIf="element.pendingPercent > 0" [style.width.%]="element.pendingPercent"
                      class="h-full bg-[#ACB9C1]" [title]="'Pending: ' + element.pending"></div>
                  </div>
                </td>
              </ng-container>
              }
              @else if (header.id === 'complete') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <span class="font-semibold text-xs"
                    [ngStyle]="{ color: element.completeVal >= 70 ? '#519C66' : element.completeVal > 0 ? '#8D6E63' : '#8D6E63' }">
                    {{ element.complete || '0%' }}
                  </span>
                </td>
              </ng-container>
              }
              @else if (header.id === 'storeAction') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <button type="button"
                    class="flex items-center gap-1 text-xs font-medium text-[#002B49] hover:underline cursor-pointer"
                    (click)="selectRow($event, element)">
                    <span>View details</span>
                    <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.33337 8H12.6667M12.6667 8L8.00004 3.33334M12.6667 8L8.00004 12.6667" stroke="#002B49"
                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </button>
                </td>
              </ng-container>
              }


              @else if (
              header.id === 'isCheckInImageRequired' ||
              header.id === 'isAbleToMapStore' ||
              header.id === 'isMultipleBrand' ||
              header.id === 'isCheckinCheckoutValidation' ||
              header.id === 'starProduct' ||
              header.id === 'isPricePromotion' ||
              header.id === 'isMobileAccess' ||
              header.id === 'isWebAccess'
              ) {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  <mat-slide-toggle class="example-margin" [checked]="element[header.id]"
                    (click)="$event.stopPropagation()" (change)="
                            toggleDynamicStatus(
                              element.id,
                              header.id,
                              element[header.id]
                            )
                          ">
                  </mat-slide-toggle>
                </td>
              </ng-container>
              } @else if (header.id === 'is_executed') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="text-center">
                  <span class="font-bold px-2 py-1 rounded" [ngStyle]="{
                            color:
                              element.is_executed === true
                                ? '#339933'
                                : '#f44336',
                          }">
                    {{ element.is_executed === true ? 'YES' : 'NO' }}
                  </span>
                </td>
              </ng-container>
              } @else if (header.id === 'attendanceStatus' || header.id === 'quizAttended') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="text-center">
                  <span class="p-2 font-medium whitespace-nowrap"
                    [ngClass]="getAttendanceStatusClass(element[header.id])">
                    {{
                    element[header.id] !== null &&
                    element[header.id] !== undefined &&
                    element[header.id] !== ''
                    ? element[header.id]
                    : '--'
                    }}
                  </span>
                </td>
              </ng-container>
              } @else if (header.id === 'is_promotionactivewhileleaving') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="promotion-active-column">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="text-center promotion-active-column">
                  <span class="font-bold px-2 py-1 rounded" [ngStyle]="{
                            color:
                              element.is_promotionactivewhileleaving === true
                                ? '#339933'
                                : '#f44336',
                          }">
                    {{
                    element.is_promotionactivewhileleaving === true
                    ? 'YES'
                    : 'NO'
                    }}
                  </span>
                </td>
              </ng-container>
              } @else if (header.id === 'rrp') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="text-center">
                  <mat-chip-set class="whitespace-nowrap">
                    <mat-chip class="bg-blue-100 text-blue-800 font-medium">
                      {{ element.rrp || '--' }}
                    </mat-chip>
                  </mat-chip-set>
                </td>
              </ng-container>
              } @else if (header.id === 'go_price') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="text-center">
                  <mat-chip-set class="whitespace-nowrap">
                    <mat-chip class="bg-green-100 text-green-800 font-medium">
                      {{ element.go_price || '--' }}
                    </mat-chip>
                  </mat-chip-set>
                </td>
              </ng-container>
              } @else if (header.id === 'reasonfornotimplemented') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="reason-not-executed-column">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="reason-not-executed-column">
                  <div>
                    {{
                    element[header.id] !== null &&
                    element[header.id] !== undefined &&
                    element[header.id] !== ''
                    ? element[header.id]
                    : ''
                    }}
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'remarks_reasonfornotimplemented') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="promotion-active-column">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="promotion-active-column">
                  <div>
                    {{
                    element[header.id] !== null &&
                    element[header.id] !== undefined &&
                    element[header.id] !== ''
                    ? element[header.id]
                    : ''
                    }}
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'promotionactivewhileleaving') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="promotion-not-active-column">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="promotion-not-active-column">
                  <div>
                    {{
                    element[header.id] !== null &&
                    element[header.id] !== undefined &&
                    element[header.id] !== ''
                    ? element[header.id]
                    : ''
                    }}
                  </div>
                </td>
              </ng-container>
              } @else if (
              header.id === 'remarks_promotionactivewhileleaving'
              ) {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="promotion-not-active-column">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false" class="promotion-not-active-column">
                  <div>
                    {{
                    element[header.id] !== null &&
                    element[header.id] !== undefined &&
                    element[header.id] !== ''
                    ? element[header.id]
                    : ''
                    }}
                  </div>
                </td>
              </ng-container>
              }

              <!-- Target -->
              @else if (header.id === 'target') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  class="target whitespace-nowrap" (mouseleave)="element.isHidden = false">
                  <!-- Explicit check for 0 -->
                  {{
                  element.target !== null &&
                  element.target !== undefined
                  ? element.target
                  : ''
                  }}
                </td>
              </ng-container>
              } @else if (header.id === 'user_storeBtn') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <!-- {{ element.roleId }} -->
                  <ng-container *ngIf="
                            !element.hideUserStoreBtn &&
                            isLevelFourGroupRole(element.roleId);
                            else noStore
                          ">
                    <button
                      class="font-bold text-md rounded-md px-2 h-9 flex items-center justify-center relative 'bg-transparent', text-mdPrimary-500 border-2 border-solid border-mdPrimary-500 hover:bg-mdPrimary-500 hover:text-e-white-text"
                      (click)="
                              userStore(element); $event.stopPropagation()
                            ">
                      Store Map
                      <span class="min-w-4">{{
                        element.storeCount
                        }}</span>
                    </button>
                  </ng-container>
                  <ng-template #noStore>
                    <span class="text-gray-500">--</span>
                  </ng-template>
                </td>
              </ng-container>
              } @else if (header.id === 'survey_mapBtn') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="
                            showInteluxUserActions(element);
                            else noSurvey
                          ">
                    <button
                      class="font-bold text-md rounded-md px-2 h-9 flex items-center justify-center relative bg-transparent text-mdPrimary-500 border-2 border-solid border-mdPrimary-500 hover:bg-mdPrimary-500 hover:text-e-white-text"
                      (click)="
                              surveyMap(element); $event.stopPropagation()
                            ">
                      Survey Map
                    </button>
                  </ng-container>
                  <ng-template #noSurvey>
                    <span class="text-gray-500">--</span>
                  </ng-template>
                </td>
              </ng-container>
              } @else if (header.id === 'resetPasswordBtn') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="
                            showInteluxUserActions(element);
                            else noReset
                          ">
                    <button
                      class="font-bold text-md rounded-md px-2 h-9 flex items-center justify-center relative bg-transparent text-mdPrimary-500 border-2 border-solid border-mdPrimary-500 hover:bg-mdPrimary-500 hover:text-e-white-text"
                      (click)="
                              resetPasswordUser(element);
                              $event.stopPropagation()
                            ">
                      Reset Password
                    </button>
                  </ng-container>
                  <ng-template #noReset>
                    <span class="text-gray-500">--</span>
                  </ng-template>
                </td>
              </ng-container>
              } @else if (header.id === 'resetStoreLocationBtn') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <button
                    class="font-bold text-md text-nowrap rounded-md px-2 h-9 flex items-center justify-center relative bg-transparent text-mdPrimary-500 border-2 border-solid border-mdPrimary-500 hover:bg-mdPrimary-500 hover:text-e-white-text"
                    (click)="
                            resetStoreLocationBtn(element);
                            $event.stopPropagation()
                          ">
                    Reset Store Location
                  </button>
                </td>
              </ng-container>
              } @else if (header.id === 'snag_status_name') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="rounded-lg p-1 px-3 w-fit text-xs font-semibold whitespace-nowrap" [ngStyle]="{
                            color: getTextColor(element.snag_status_name),
                            backgroundColor: getBackgroundColor(
                              element.snag_status_name
                            ),
                          }">
                    {{ element.snag_status_name }}
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'priority') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <div
                    class="rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-wider w-fit whitespace-nowrap"
                    [ngClass]="{
                            'bg-red-50 text-red-600 border border-red-100':
                              element.priority?.toLowerCase() === 'high',
                            'bg-orange-50 text-orange-600 border border-orange-100':
                              element.priority?.toLowerCase() === 'medium',
                            'bg-blue-50 text-blue-600 border border-blue-100':
                              element.priority?.toLowerCase() === 'low',
                          }">
                    {{ element.priority }}
                  </div>
                </td>
              </ng-container>
              } @else if (header.id === 'comments') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="rounded-lg p-1 px-3 z] min-w-[120px] max-w-[250px] text-wrap text-xs font-semibold">
                    {{ element.comments }}
                  </div>
                </td>
              </ng-container>
              }
              @else if (header.id === 'comparison_result') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="rounded-lg p-1 px-3 text-wrap text-center">
                    {{ element.comparison_result }}
                  </div>
                </td>
              </ng-container>
              }
              @else if (header.id === 'assessment_level_types') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="text-wrap text-center text-[15px] font-bold">
                    {{ element.assessment_level_types }}
                  </div>
                </td>
              </ng-container>
              }
              @else if (header.id === 'engagement_type') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="text-wrap text-center text-[15px] font-bold">
                    {{ element.engagement_type }}
                  </div>
                </td>
              </ng-container>
              }
              @else if (header.id === 'recommendations') {
              <ng-container>
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="text-wrap text-center text-[15px] font-bold">
                    {{ element.recommendations }}
                  </div>
                </td>
              </ng-container>
              }
              <!-- total -->
              <ng-container *ngIf="header.id === 'promoter_brand'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element[header.id] }}
                </td>

                <ng-container *ngIf="grandTotalValue">
                  <td mat-footer-cell *matFooterCellDef style="background-color: #011e41">
                    <div class="font-extrabold text-white">Total</div>
                  </td>
                </ng-container>
              </ng-container>
              <!-- promoter share table -->
              <ng-container *ngIf="
                      [
                        'JAN-2025',
                        'FEB-2025',
                        'MAR-2025',
                        'APR-2025',
                        'MAY-2025',
                        'JUN-2025',
                        'JUL-2025',
                        'AUG-2025',
                        'SEP-2025',
                        'OCT-2025',
                        'NOV-2025',
                        'DEC-2025',
                      ].includes(header.id)
                    ">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="w-full h-full flex items-center justify-center">
                    {{ header.key }}
                  </div>
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  <div class="text-center">
                    {{ element[header.id] }}
                  </div>
                </td>

                <ng-container *ngIf="grandTotalValue">
                  <td mat-footer-cell *matFooterCellDef style="background-color: #011e41">
                    <div class="font-extrabold text-center text-white">
                      {{ grandTotalValue[header.id] }}
                    </div>
                  </td>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="header.id === 'updatedAt'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  <div class="w-36">
                    {{
                    element[header.id]
                    ? (element[header.id] | date: 'yyyy-MM-dd')
                    : '--'
                    }}
                  </div>
                </td>
              </ng-container>

              <!-- dob -->
              <ng-container *ngIf="
                      [
                        'dob',
                        'requestedDate',
                        'startDate',
                        'endDate',
                        'startdate',
                        'enddate',
                        'approvedDate',
                        'inviteDate',
                        'date',
                        'displayPlanogramDate',
                        'display_share_date',
                        'display_date',
                        'displayDate',
                        'saleDate',
                        'created_at',
                        'created_date',
                        'created_date_time',
                        'updated_date_time',
                        'resolved_date_time',
                        'estimated_resolve_date',
                      ].includes(header.id)
                    ">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="
                        dataSource?.data?.length > 0 &&
                        (header.id === 'startdate' || header.id === 'enddate')
                          ? 'grosspricedates'
                          : ''
                      ">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  <div class="w-24">
                    {{
                    element[header.id]
                    ? (element[header.id] | date: 'dd-MM-yyyy')
                    : '--'
                    }}
                  </div>
                </td>

                <ng-container *ngIf="grandTotalValue">
                  <td mat-footer-cell *matFooterCellDef style="background-color: #011e41">
                    <div class="font-extrabold text-center text-white"></div>
                  </td>
                </ng-container>
              </ng-container>


              <!-- dob -->
              <ng-container *ngIf="
                      [
                        'created_by_name',
                        'resolved_by_name',
                        'updated_by_name',
                      ].includes(header.id)
                    ">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>

                <td mat-cell *matCellDef="let element">
                  <div class="user-cell">
                    @if (
                    !!element[header.id] && element[header.id] !== ' '
                    ) {
                    <div class="initial-circle" [ngStyle]="{
                              'background-color': getColorForName(
                                element[header.id]
                              ),
                            }">
                      {{ getInitials(element[header.id]) }}
                    </div>

                    <span class="user-name">
                      {{ element[header.id] }}
                    </span>
                    } @else {
                    <div class="w-full text-center">{{ '--' }}</div>
                    }
                  </div>
                </td>
              </ng-container>

              <!-- countries -->
              <ng-container *ngIf="header.id === 'countries'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  <ng-container *ngIf="element.countries.length > 0; else noCountries">
                    <mat-chip-set class="whitespace-nowrap">
                      <mat-chip *ngFor="let countryName of element.countries">{{ countryName }}</mat-chip>
                    </mat-chip-set>
                  </ng-container>

                  <ng-template #noCountries>
                    <span></span>
                  </ng-template>
                </td>
              </ng-container>

              <!-- region -->
              <ng-container *ngIf="header.id === 'region'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  {{ element[header.id]?.name }}
                </td>
              </ng-container>

              <!-- total -->
              <ng-container *ngIf="header.id === 'store_code'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element[header.id] }}
                </td>

                <ng-container *ngIf="grandTotalValue">
                  <td mat-footer-cell *matFooterCellDef style="background-color: #011e41">
                    <div class="font-extrabold text-white">Total</div>
                  </td>
                </ng-container>
              </ng-container>

              <!-- language -->
              <ng-container *ngIf="header.id === 'language'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  {{
                  element[header.id]?.name
                  ? element[header.id]?.name
                  : '---'
                  }}
                </td>
              </ng-container>

              <!-- store -->
              <ng-container *ngIf="header.id === 'name'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  <div class="truncate-text" [matTooltip]="element[header.id]">
                    {{ element[header.id] ? element[header.id] : '---' }}
                  </div>
                </td>
              </ng-container>

              <!-- channel -->
              <ng-container *ngIf="header.id === 'channel'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true" class="whitespace-nowrap"
                  (mouseleave)="element.isHidden = false">
                  {{ element[header.id]?.name || element[header.id] }}
                </td>
              </ng-container>
              <!-- brand -->
              <ng-container *ngIf="header.id === 'brand'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="whitespace-nowrap cursor-default ">
                  <div class="w-full text-center">
                    <ng-container *ngIf="
                          element[header.id] && element[header.id].trim() !== ''
                        ">
                      <mat-chip-set aria-label="Brand selection text-selection" class="whitespace-nowrap">
                        <mat-chip *ngFor="let brand of element[header.id]?.split(',')">{{ brand.trim() }}</mat-chip>
                      </mat-chip-set>
                    </ng-container>
                    <ng-container *ngIf="
                          !element[header.id] ||
                          element[header.id].trim() === ''
                        ">
                      <span></span>
                    </ng-container>
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'categories'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="whitespace-nowrap cursor-default">
                  <ng-container *ngIf="
                          element[header.id] && element[header.id].trim() !== ''
                        ">
                    <mat-chip-set aria-label="Categories selection text-selection" class="whitespace-nowrap">
                      <mat-chip *ngFor="
                              let category of element[header.id]?.split(',')
                            ">{{ category.trim() }}</mat-chip>
                    </mat-chip-set>
                  </ng-container>
                  <ng-container *ngIf="
                          !element[header.id] ||
                          element[header.id].trim() === ''
                        ">
                    <span></span>
                  </ng-container>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'subCategories'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="whitespace-nowrap cursor-default">
                  <ng-container *ngIf="
                          element[header.id] && element[header.id].trim() !== ''
                        ">
                    <mat-chip-set aria-label="Categories selection text-selection" class="whitespace-nowrap">
                      <mat-chip *ngFor="
                              let category of element[header.id]?.split(',')
                            ">{{ category.trim() }}</mat-chip>
                    </mat-chip-set>
                  </ng-container>
                  <ng-container *ngIf="
                          !element[header.id] ||
                          element[header.id].trim() === ''
                        ">
                    <span></span>
                  </ng-container>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'subCategories'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="whitespace-nowrap cursor-default">
                  <ng-container *ngIf="
                          element[header.id] && element[header.id].trim() !== ''
                        ">
                    <mat-chip-set aria-label="Categories selection" class="whitespace-nowrap">
                      <mat-chip *ngFor="
                              let category of element[header.id]?.split(',')
                            ">{{ category.trim() }}</mat-chip>
                    </mat-chip-set>
                  </ng-container>
                  <ng-container *ngIf="
                          !element[header.id] ||
                          element[header.id].trim() === ''
                        ">
                    <span></span>
                  </ng-container>
                </td>
              </ng-container>

              <!-- reporting_manager -->
              <ng-container *ngIf="header.id === 'reporting_manager'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="whitespace-nowrap cursor-default">
                  {{
                  element[header.id].length > 0
                  ? element[header.id]
                  : '--'
                  }}
                </td>
              </ng-container>

              <!-- segment -->
              <ng-container *ngIf="header.id === 'segment'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="whitespace-nowrap cursor-default">
                  <ng-container *ngIf="
                          element[header.id] && element[header.id].trim() !== ''
                        ">
                    <mat-chip-set aria-label="Segment selection" class="whitespace-nowrap">
                      <mat-chip *ngFor="
                              let segment of element[header.id]?.split(',')
                            ">{{ segment.trim() }}</mat-chip>
                    </mat-chip-set>
                  </ng-container>
                  <ng-container *ngIf="
                          !element[header.id] ||
                          element[header.id].trim() === ''
                        ">
                    <span></span>
                  </ng-container>
                </td>
              </ng-container>

              <!-- region page -> country -->
              <ng-container *ngIf="header.id === 'countriesName'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="whitespace-nowrap cursor-default">
                  <ng-container *ngIf="
                          element[header.id] && element[header.id].trim() !== ''
                        ">
                    <mat-chip-set class="whitespace-nowrap">
                      <mat-chip *ngFor="
                              let countriesName of element[header.id]?.split(
                                ','
                              )
                            ">{{ countriesName.trim() }}</mat-chip>
                    </mat-chip-set>
                  </ng-container>
                  <ng-container *ngIf="
                          !element[header.id] ||
                          element[header.id].trim() === ''
                        ">
                    <span></span>
                  </ng-container>
                </td>
              </ng-container>

              <!-- state -->
              <ng-container *ngIf="header.id === 'state'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="whitespace-nowrap cursor-default">
                  <ng-container *ngIf="
                          element[header.id] && element[header.id].trim() !== ''
                        ">
                    <mat-chip-set class="whitespace-nowrap">
                      <mat-chip *ngFor="let state of element[header.id]?.split(',')">{{ state.trim() }}</mat-chip>
                    </mat-chip-set>
                  </ng-container>
                  <ng-container *ngIf="
                          !element[header.id] ||
                          element[header.id].trim() === ''
                        ">
                    <span></span>
                  </ng-container>
                </td>
              </ng-container>
              <!-- city -->
              <ng-container *ngIf="header.id === 'city'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="whitespace-nowrap cursor-default">
                  <ng-container *ngIf="
                          element[header.id] && element[header.id].trim() !== ''
                        ">
                    <mat-chip-set class="whitespace-nowrap">
                      <mat-chip *ngFor="let city of element[header.id]?.split(',')">{{ city.trim() }}</mat-chip>
                    </mat-chip-set>
                  </ng-container>
                  <ng-container *ngIf="
                          !element[header.id] ||
                          element[header.id].trim() === ''
                        ">
                    <span></span>
                  </ng-container>
                </td>
              </ng-container>

              <!-- account -->

              <ng-container *ngIf="header.id === 'account'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true" class="whitespace-nowrap"
                  (mouseleave)="element.isHidden = false">
                  {{ element[header.id]?.name || element[header.id] }}
                </td>
              </ng-container>

              <!-- country -->

              <ng-container *ngIf="header.id === 'country'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  {{ isAnArray(element[header.id]) }}
                </td>
              </ng-container>
              <!-- isCompetitor -->
              <ng-container *ngIf="header.id === 'isCompetitor'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  {{ element.isCompetitor === true ? 'Yes' : 'No' }}
                </td>
              </ng-container>

              <!-- Promoter for Store -->
              <!-- <ng-container *ngIf="header.id === 'isPromoter'">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ header.key }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                (mouseenter)="element.isHidden = true"
                (mouseleave)="element.isHidden = false"
              >
                {{ element.isPromoter === true ? 'Yes' : 'No' }}
              </td>
            </ng-container> -->
              <!-- address -->
              <ng-container *ngIf="header.id === 'store'">
                <th mat-header-cell *matHeaderCellDef>{{ header.key }}</th>
                <td mat-cell *matCellDef="let element" [matTooltip]="element.store?.join(', ')">
                  <div class="truncate w-40">
                    <span>{{ element.store?.length || 0 }}</span>
                    <!-- Display store count -->
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="['storeAdress', 'address'].includes(header.id)">
                <th mat-header-cell *matHeaderCellDef>{{ header.key }}</th>
                <td mat-cell *matCellDef="let element; let i = index" matTooltip="{{ element.storeAdress }},{{
                        element.address
                      }}">
                  <div class="truncate w-40">
                    <span>{{ element[header.id] }}</span>
                  </div>
                </td>
              </ng-container>
              <!-- name -->
              <ng-container *ngIf="header.id === 'firstName'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  {{
                  element.firstName
                  ? element.firstName + ' ' + element.lastName
                  : ''
                  }}
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'approvalstatus'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Approval status
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="flex">
                    <div class="mt-[5px] mr-1.5 h-2.5 w-2.5 rounded-full" [ngStyle]="{
                            backgroundColor: getColor(element.approvalstatus),
                          }"></div>
                    <div>{{ element.approvalstatus }}</div>
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'approved_by'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <lib-avatar *ngIf="element.approved_by" [approvalMembers]="[element.approved_by].sort()"></lib-avatar>
                  <span class="approved-avatar ml-5" *ngIf="!element.approved_by"></span>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'approver'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div class="flex items-center justify-center gap-1">
                    <ng-container *ngIf="
                            getApproverList(element.approver).length > 0;
                            else noApprover
                          ">
                      <div *ngFor="
                              let approver of getApproverList(element.approver)
                                | slice: 0 : 3;
                              let i = index
                            " class="approver-circle" [matTooltip]="approver">
                        {{ getInitials(approver) }}
                      </div>
                      <div *ngIf="getApproverList(element.approver).length > 3" class="approver-more"
                        [matTooltip]="getApproverTooltip(element.approver)">
                        +{{ getApproverList(element.approver).length - 3 }}
                      </div>
                    </ng-container>
                    <ng-template #noApprover>
                      <span class="text-gray-400">--</span>
                    </ng-template>
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'ro_full_name'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div class="flex items-center justify-center gap-1">
                    <ng-container *ngIf="
                            getApproverList(element.ro_full_name).length > 0;
                            else noRoFullName
                          ">
                      <div *ngFor="
                              let ro of getApproverList(element.ro_full_name)
                                | slice: 0 : 3;
                              let i = index
                            " class="approver-circle" [matTooltip]="ro">
                        {{ getInitials(ro) }}
                      </div>
                      <div *ngIf="
                              getApproverList(element.ro_full_name).length > 3
                            " class="approver-more" [matTooltip]="
                              getApproverTooltip(element.ro_full_name)
                            ">
                        +{{
                        getApproverList(element.ro_full_name).length - 3
                        }}
                      </div>
                    </ng-container>
                    <ng-template #noRoFullName>
                      <span class="text-gray-400">--</span>
                    </ng-template>
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'invoicePriceUnit'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="invoicePriceUnit whitespace-nowrap"
                  style="text-align: center">
                  <span>{{ element.invoicePriceUnit }}</span>
                  <span *ngIf="!element.invoicePriceUnit"></span>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'total'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element"
                  class="text-center invoicePriceUnit whitespace-nowrap items-center" style="text-align: center">
                  <span>{{ element.total }}</span>
                  <span *ngIf="!element.total"></span>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'grossPriceUnit'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="grossPriceUnit whitespace-nowrap"
                  style="text-align: center">
                  <span>{{ element.grossPriceUnit }}</span>
                  <span *ngIf="!element.grossPriceUnit"></span>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'grossPriceTotal'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="grossPriceTotal whitespace-nowrap"
                  style="text-align: center">
                  <span>{{ element.grossPriceTotal }}</span>
                  <span *ngIf="!element.grossPriceTotal"></span>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'quantity'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="quantity whitespace-nowrap" style="text-align: center">
                  <span *ngIf="
                          element.quantity === null ||
                          element.quantity === undefined
                        "></span>
                  <span *ngIf="
                          element.quantity !== null &&
                          element.quantity !== undefined
                        ">{{ element.quantity }}</span>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'displayCount'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="">
                  <div class="w-full text-center">{{ header.key }}</div>
                </th>
                <td mat-cell *matCellDef="let element" class="whitespace-nowrap" style="text-align: center">
                  <span *ngIf="
                          element.displayCount === null ||
                          element.displayCount === undefined
                        "></span>
                  <span *ngIf="
                          element.displayCount !== null &&
                          element.displayCount !== undefined
                        ">{{ element.displayCount }}</span>
                </td>
              </ng-container>
              <ng-container *ngIf="header.id === 'displayShare'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="">
                  <div class="w-full text-center">{{ header.key }}</div>
                </th>
                <td mat-cell *matCellDef="let element" class="whitespace-nowrap" style="text-align: center">
                  <span *ngIf="
                          element.displayShare === null ||
                          element.displayShare === undefined
                        "></span>
                  <span *ngIf="
                          element.displayShare !== null &&
                          element.displayShare !== undefined
                        ">{{ element.displayShare }}</span>
                </td>
              </ng-container>

              <!-- grossprice and price for the "productgrosspricedetails" -->
              <ng-container *ngIf="header.id === 'grossprice'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="grossprice whitespace-nowrap" style="text-align: center">
                  <span>{{ element.grossprice }}</span>
                  <span *ngIf="!element.grossprice">--</span>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'price'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="price whitespace-nowrap" style="text-align: center">
                  <span>{{ element.price }}</span>
                  <span *ngIf="!element.price"></span>
                </td>
              </ng-container>

              <!-- end -->

              <!--             <ng-container *ngIf="header.id === 'saleDate'">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ header.key }}
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                class="text-center saleDate"
              >
                <span>{{ element.saleDate }}</span>
                <span *ngIf="!element.saleDate"></span>
              </td>
            </ng-container> -->

              <ng-container *ngIf="header.id === 'task_status'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Status
                </th>
                <td mat-cell *matCellDef="let element">
                  <!-- Apply dynamic styles -->

                  <div class="rounded-lg p-1 w-fit" [ngStyle]="{
                          color: getTextColor(element.task_status),
                          backgroundColor: getBackgroundColor(
                            element.task_status
                          ),
                        }">
                    {{ element.task_status }}
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'incentive_status'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="flex items-center justify-center w-full">
                    <!-- Apply dynamic styles -->

                    <div class="rounded-lg p-2 w-24 text-center" [ngStyle]="{
                            color: getTextColor(element.incentive_status),
                            backgroundColor: getBackgroundColor(
                              element.incentive_status
                            ),
                          }">
                      {{ element.incentive_status }}
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'training_attendees_status'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="flex items-center justify-center w-full">
                    <!-- Apply dynamic styles -->

                    <div class="rounded-lg p-2 w-24 text-center" [ngStyle]="{
                            color: getTextColor(
                              element.training_attendees_status
                            ),
                            backgroundColor: getBackgroundColor(
                              element.training_attendees_status
                            ),
                          }">
                      {{ element.training_attendees_status }}
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'stores'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true" class="whitespace-nowrap"
                  (mouseleave)="element.isHidden = false">
                  {{ element.stores.length }} Stores
                </td>
              </ng-container>
              <ng-container *ngIf="header.id === 'noOfStores'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="">
                  <div class="w-full text-center">{{ header.key }}</div>
                </th>
                <td mat-cell *matCellDef="let element" (mouseenter)="element.isHidden = true" class="whitespace-nowrap"
                  (mouseleave)="element.isHidden = false">
                  <div class="w-full text-center">
                    {{ element[header.id] }}
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="['beforeImage2', 'afterImage2'].includes(header.id)">
                <th class="px-6 py-3 whitespace-nowrap images_columns" mat-header-cell *matHeaderCellDef>
                  {{ header.key }}
                </th>
                <td class="px-6 py-4 cursor-pointer" mat-cell *matCellDef="let element">
                  <img class="rounded h-20 max-w-full max-h-full py-2" [src]="getImageSource(element, header.id)"
                    (error)="handleImageError($event)" alt="Store-Image" />
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'sno'">
                <th mat-header-cell *matHeaderCellDef>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index" (mouseenter)="element.isHidden = true"
                  (mouseleave)="element.isHidden = false">
                  {{ getSerialNumber(i) }}
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'storeAddress'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="storeAddress whitespace-wrap">
                  <span *ngIf="
                          element.storeAddress === null ||
                          element.storeAddress === undefined
                        "></span>
                  <div class="truncate w-48" *ngIf="
                          element.storeAddress !== null &&
                          element.storeAddress !== undefined
                        ">
                    {{ element.storeAddress }}
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'factor_name'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <div class="font-bold">{{ element.factor_name }}</div>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'weightage'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{ element.weightage | number: '1.0-0' }}%
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'retailer_weighted'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{ element.retailer_weighted | number: '1.0-0' }}%
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'elx_weighted'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{ element.elx_weighted | number: '1.0-0' }}%
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'total_weighted'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{ element.total_weighted | number: '1.0-0' }}%
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'retailer_score'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="w-32">
                    {{ header.key }}
                  </div>
                </th>

                <td mat-cell *matCellDef="let element; let i = index" class="w-32">
                  <div [ngClass]="getScoreClass(element.retailer_score)" class="text-center w-32">
                    {{ element.retailer_score | number: '1.0-0' }}%
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'elx_score'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <div class="w-32">
                    {{ header.key }}
                  </div>
                </th>
                <td mat-cell *matCellDef="let element; let i = index" class="w-32">
                  <div [ngClass]="getScoreClass(element.elx_score)" class="text-center w-32">
                    {{ element.elx_score | number: '1.0-0' }}%
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'salescontribution'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <div class="font-bold" [ngClass]="getScoreClass(element.salescontribution)">
                    {{ element.salescontribution != null ? ((element.salescontribution | number:'1.0-0') + '%') : '---'
                    }}
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'rangefrom'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{
                  element?.rangefrom !== null
                  ? (element.rangefrom | number: '1.0-0') + '%'
                  : '--'
                  }}
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'rangeFrom'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{
                  element?.rangeFrom !== null
                  ? (element.rangeFrom | number: '1.0-0') + '%'
                  : '--'
                  }}
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'rangeto'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{
                  element?.rangeto !== null
                  ? (element.rangeto | number: '1.0-0') + '%'
                  : '--'
                  }}
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'rangeTo'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{
                  element?.rangeTo !== null
                  ? (element.rangeTo | number: '1.0-0') + '%'
                  : '--'
                  }}
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'incentive'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  {{
                  element?.incentive !== null
                  ? element.incentive + '%'
                  : '--'
                  }}
                </td>
              </ng-container>

              <ng-container *ngIf="header.id === 'location'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="location whitespace-wrap">
                  <span *ngIf="
                          element.location === null ||
                          element.location === undefined
                        "></span>
                  <span *ngIf="
                          element.location !== null &&
                          element.location !== undefined
                        ">{{ element.location }}</span>
                </td>
              </ng-container>


              <ng-container *ngIf="header.id === 'type'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <div [ngClass]="[
                          element.type === 'Omnichannel'
                            ? 'text-e-support-5'
                            : element.type === 'Retail Stores'
                              ? 'text-e-support-6'
                              : 'text-mdPrimary-500',
                          'type_capitalize',
                        ]" class="font-semibold text-center">
                    {{ element?.type !== null ? element?.type : '--' }}
                  </div>
                </td>
              </ng-container>


              <ng-container *ngIf="header.id === 'invoiceUrl'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div *ngIf="element.invoiceUrl" class="invoice-preview">
                    <!-- Image preview -->
                    <div class="preview-container" (click)="openInvoicePreview(element.invoiceUrl)">
                      <!-- Image with loading state -->
                      <ng-container *ngIf="isImageUrl(element.invoiceUrl)">
                        <div class="loading-placeholder" *ngIf="!element.imageLoaded"></div>
                        <img [src]="
                                element.invoicePreviewUrl ||
                                getInvoicePreviewUrl(element)
                              " alt="Invoice Preview" loading="lazy" (load)="element.imageLoaded = true"
                          [class.opacity-0]="!element.imageLoaded" [class.opacity-100]="element.imageLoaded" />
                      </ng-container>

                      <!-- PDF Icon -->
                      <ng-container *ngIf="isPdfUrl(element.invoiceUrl)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                          <polyline points="14 2 14 8 20 8"></polyline>
                          <line x1="16" y1="13" x2="8" y2="13"></line>
                          <line x1="16" y1="17" x2="8" y2="17"></line>
                          <line x1="10" y1="9" x2="8" y2="9"></line>
                        </svg>
                      </ng-container>
                    </div>
                  </div>
                </td>
              </ng-container>
              <!-- images -->
              <ng-container *ngIf="
                      [
                        'selfi_img',
                        'beforeImage1',
                        'afterImage1',
                        'taggedImageurl',
                        'untaggedImageurl',
                        'image_url',
                        'pre-test-image',
                        'post-test-image',
                        'image',
                        'resolved_image',
                      ].includes(header.id)
                    ">
                <th class="px-6 py-3 whitespace-nowrap images_columns" mat-header-cell *matHeaderCellDef>
                  <div class="w-full h-full flex items-center justify-center">
                    {{ header.key }}
                  </div>
                </th>
                <td class="px-6 py-4 cursor-pointer" mat-cell *matCellDef="let element"
                  (click)="openModal(element[header.id], $event)">
                  <div class="w-full h-full flex items-center justify-center">
                    <img
                      class="w-10 h-10 overflow-hidden rounded-lg cursor-pointer relative flex items-center justify-center"
                      [src]="getImageSource(element, header.id)" (error)="handleImageError($event)" loading="lazy"
                      alt="Store-Image" />
                  </div>
                </td>
              </ng-container>
              <ng-container *ngIf="isClampedListColumn(header.id)">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="table-clamped-cell">
                  <span *ngIf="
                          element[header.id] === null ||
                          element[header.id] === undefined
                        "></span>
                  <span *ngIf="element[header.id] === '--'">--</span>
                  <ng-container *ngIf="getCellListText(element[header.id]) as cellText">
                    <div class="table-clamped-cell__text">
                      {{ cellText }}
                    </div>
                    <button *ngIf="shouldShowMoreForCell(element[header.id])" type="button"
                      class="table-clamped-cell__more" [matTooltip]="cellText" matTooltipClass="table-clamped-tooltip"
                      matTooltipPosition="below" #moreTip="matTooltip" (click)="openCellMoreTooltip(moreTip, $event)">
                      Show more
                    </button>
                  </ng-container>
                </td>
              </ng-container>

              <!-- target input field  -->
              <ng-container *ngIf="header.id === 'target_input'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="whitespace-nowrap">
                  {{ header.key }}
                </th>
                <td mat-cell *matCellDef="let element" class="whitespace-wrap">
                  <input type="text" placeholder="Enter target" maxlength="7" (keypress)="
                          ($event.charCode >= 48 && $event.charCode <= 57)
                        " [(ngModel)]="element.target_input" (ngModelChange)="onTargetChange(dataSource?.data)"
                    class="w-[70%] min-w-[300px] px-2 py-1 border border-gray-400 rounded focus:outline-none focus:ring-0 focus:border-gray-400" />
                </td>
              </ng-container>
            </ng-container>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsList; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: columnsList" (click)="selectRow($event, row)" [ngClass]="{
                  'grand-total-row': row.brand_name === 'Grand Total',
                  'cursor-pointer hover:bg-gray-50': selectRowClick.observers.length > 0
                }"></tr>

          <ng-container *ngIf="grandTotalValue">
            <tr mat-footer-row *matFooterRowDef="columnsList"></tr>
          </ng-container>
          <tr class="mat-row no-data-row" *matNoDataRow>
            <td class="mat-cell noData" [attr.colspan]="columnsList.length || 1">
              <div class="no-data-content">
                <lib-data-not-found></lib-data-not-found>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="fake-scrollbar-horizontal" *ngIf="showHorizontalScrollbar">
        <div class="fake-scrollbar-track-horizontal" #horizontalTrack
          (mousedown)="onHorizontalScrollbarMouseDown($event)">
          <div class="fake-scrollbar-thumb-horizontal" #horizontalThumb [style.left.px]="horizontalThumbLeft"
            [style.width.px]="horizontalThumbWidth"></div>
        </div>
      </div>
      <div class="fake-scrollbar-vertical" *ngIf="showVerticalScrollbar">
        <div class="fake-scrollbar-track-vertical" #verticalTrack (mousedown)="onVerticalScrollbarMouseDown($event)">
          <div class="fake-scrollbar-thumb-vertical" #verticalThumb [style.top.px]="verticalThumbTop"
            [style.height.px]="verticalThumbHeight"></div>
        </div>
      </div>
    </div>
    <div class="w-full" *ngIf="!customizedPagiantor" [ngClass]="fixedHeader ? 'overflow-x-auto' : ''">
      <lib-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [totalCount]="totalCount" [from]="from" [to]="to"
        [page]="page" (pageSizeChange)="pageSizeChangeTable($event)" (decrementValue)="decrementValueTable($event)"
        (incrementValue)="incrementValueTable($event)" (overDecrementValue)="overDecrementValueTable()"
        (overIncrementValue)="overIncrementValueTable($event)"></lib-paginator>
    </div>
  </div>
</ng-container>
} @else {
<tr class="mat-row no-data-row" *matNoDataRow>
  <td class="mat-cell noData" [attr.colspan]="columnsList.length || 1">
    <div class="no-data-content">
      <lib-data-not-found></lib-data-not-found>
    </div>
  </td>
</tr>
}
}

<!-- {{ grandTotalValue | json }} -->
<!-- {{ grandTotalValue | json }} -->